<template>
    <div class="homepage">
        <section class="homepage__section homepage__intro-top">
            <div class="container">
                <h2 class="homepage__intro-top__heading" v-html="page.general.intro_top_heading"></h2>
                <h3 class="homepage__intro-top__subheading"
                    v-html="page.general.intro_top_subheading"
                    v-if="page.general.intro_top_subheading"
                ></h3>
                <a class="homepage__intro-top__video-cta"
                   v-html="page.general.intro_top_video_cta"
                   v-on:click="scrollToVideo"
                ></a>
                <div class="homepage__intro-top__btns">
                    <a class="homepage__intro-top__btn is-red" href="/register"
                       v-html="page.general.intro_top_register_cta"
                    ></a>
                    <a class="homepage__intro-top__btn is-white" href="/login"
                       v-html="page.general.intro_top_login_cta"
                    ></a>
                </div>
            </div>
            <span class="homepage__intro-top__artist">Artist: Minori | Photographer: Andrae Henry</span>
        </section>

        <section class="homepage__section homepage__intro-middle" id="watch-video">
            <div class="container">
                <div class="homepage__intro-middle__video" v-if="page.general.intro_middle_video_id">
                    <iframe v-bind:src="'https://player.vimeo.com/video/' + page.general.intro_middle_video_id + '?autoplay=0&loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media'" allowfullscreen allowtransparency></iframe>
                </div>
                <div class="homepage__intro-middle__text" v-html="page.general.intro_middle_text_filtered"></div>
            </div>
        </section>

        <section class="homepage__section homepage__intro-bottom">
            <div class="container">
                <h3 class="homepage__intro-bottom__heading" v-html="page.general.intro_bottom_heading"></h3>
                <div class="homepage__intro-bottom__text" v-html="page.general.intro_bottom_text.nl2br()"></div>
                <a class="homepage__intro-bottom__cta" href="/register"
                   v-html="page.general.intro_bottom_cta"
                ></a>
            </div>
        </section>

        <section class="homepage__section homepage__my-plan">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <h3 class="homepage__my-plan__heading" v-html="page.general.my_plan_heading"></h3>
                        <div class="homepage__my-plan__text" v-html="page.general.my_plan_text.nl2br()"></div>
                        <a class="homepage__my-plan__cta" href="/register" v-html="page.general.my_plan_cta"></a>
                    </div>
                    <div class="column">
                        <img class="homepage__my-plan__image" src="/images/homepage-my-plan-img.png?v4" height="200"
                             v-bind:alt="page.general.my_plan_heading"
                        />
                    </div>
                </div>
            </div>
        </section>

        <section class="homepage__section homepage__the-list">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <h3 class="homepage__the-list__heading" v-html="page.general.the_list_heading"></h3>
                        <div class="homepage__the-list__text" v-html="page.general.the_list_text.nl2br()"></div>
                        <a class="homepage__the-list__cta" href="/the-list" v-html="page.general.the_list_cta"></a>
                    </div>
                    <div class="column">
                        <img class="homepage__the-list__image" src="/images/homepage-the-list-img.jpg"
                             v-bind:alt="page.general.the_list_heading"
                        />
                    </div>
                </div>
            </div>
        </section>

        <section class="homepage__section homepage__executive-summary">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="homepage__executive-summary__text"
                             v-html="page.general.executive_summary_text.nl2br()"
                        ></div>
                        <div class="homepage__executive-summary__author"
                             v-html="page.general.executive_summary_author"
                        ></div>
                        <div class="homepage__executive-summary__author__title"
                             v-html="page.general.executive_summary_author_title"
                        ></div>
                    </div>
                    <div class="column">
                        <img src="/images/homepage-executive-summary-img.jpg"
                             v-bind:alt="page.general.executive_summary_text"
                        />
                    </div>
                </div>
            </div>
        </section>

        <section class="homepage__section homepage__testimonials" id="testimonials" v-if="page.testimonials">
            <div class="container">
                <div class="homepage__testimonials__carousel">
                    <div class="homepage__testimonial"
                         v-for="item in page.testimonials"
                         v-on:mousedown="moveTestimonialsStart"
                         v-on:mouseup="moveTestimonialsFinish"
                         v-on:touchstart="moveTestimonialsStart"
                         v-on:touchend="moveTestimonialsFinish"
                    >
                        <div class="columns">
                            <div class="column">
                                <img class="homepage__testimonial__picture"
                                     v-bind:alt="item.author"
                                     v-bind:src="item.picture.media.file"
                                     v-if="item.picture && item.picture.media"
                                />
                                <div class="homepage__testimonial__video" v-else>
                                    <iframe allowfullscreen allowtransparency
                                            v-bind:src="'https://player.vimeo.com/video/' + item.video + '?autoplay=0&loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media'" style="background-color: #202226;"
                                            v-if="item.video"
                                    ></iframe>
                                </div>
                            </div>
                            <div class="column">
                                <div class="homepage__testimonial__text"
                                     v-html="item.text.nl2br()"
                                     v-if="item.text"
                                ></div>
                                <div class="homepage__testimonial__author"
                                     v-html="item.author"
                                ></div>
                                <div class="homepage__testimonial__author__title"
                                     v-html="item.author_title"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <nav class="homepage__testimonials__carousel__thumbs">
                        <a v-bind:class="{ 'is-active' : key === testimonial.current }"
                           v-for="(item, key) in page.testimonials"
                           v-html="key"
                           v-on:click="gotoTestimonial(key)"
                        ></a>
                    </nav>
                </div>
            </div>
        </section>

        <section class="homepage__section homepage__pricing__banner" id="pricing">
            <div class="container">
                <h3 class="homepage__pricing__banner__heading"
                    v-html="page.general.pricing_heading_filtered.replace(/%s/, subscription.trial_length)"
                ></h3>
                <h5 class="homepage__pricing__banner__subheading" v-html="page.general.pricing_subheading"></h5>
            </div>
        </section>

        <section class="homepage__section homepage__pricing">
            <div class="container">
                <div class="homepage__pricing__text"
                     v-if="page.general.pricing_text"
                     v-html="page.general.pricing_text.nl2br()"
                ></div>
                <div class="homepage__pricing__toggle">
                    <label v-bind:class="{ 'is-selected' : selectedPlan === 'monthly'}">Pay monthly</label>
                    <span v-bind:class="{ 'is-on' : selectedPlan === 'yearly'}" v-on:click="togglePlan"></span>
                    <label v-bind:class="{ 'is-selected' : selectedPlan === 'yearly'}">Pay yearly</label>
                </div>
                <div class="homepage__pricing__options">
                    <div class="homepage__pricing__option"
                         v-bind:class="{ 'is-selected' : selectedPlan === 'monthly'}"
                         v-on:click="selectPlan('monthly')"
                    >
                        <div class="homepage__pricing__option__price">
                            <sup>$</sup><span v-html="subscription.prices.monthly"></span> / month
                        </div>
                        <ul class="homepage__pricing__option__features" v-if="page.general.pricing_monthly_features">
                            <li v-for="feature in page.general.pricing_monthly_features" v-html="feature"></li>
                        </ul>
                        <a class="homepage__pricing__option__btn homepage__pricing__option__btn--monthly"
                           href="/register"
                           v-html="page.general.pricing_monthly_cta"
                        ></a>
                    </div>
                    <div class="homepage__pricing__option"
                         v-bind:class="{ 'is-selected' : selectedPlan === 'yearly'}"
                         v-on:click="selectPlan('yearly')"
                    >
                        <div class="homepage__pricing__option__price">
                            <sup>$</sup><span v-html="subscription.prices.yearly"></span> / year
                        </div>
                        <ul class="homepage__pricing__option__features" v-if="page.general.pricing_yearly_features">
                            <li v-for="feature in page.general.pricing_yearly_features" v-html="feature"></li>
                        </ul>
                        <a class="homepage__pricing__option__btn homepage__pricing__option__btn--yearly"
                           href="/register"
                           v-html="page.general.pricing_yearly_cta"
                        ></a>
                    </div>
                </div>
            </div>
        </section>

        <section class="homepage__section homepage__outro" v-if="page.general.outro_text">
            <div class="container">
                <div class="homepage__outro__text" v-html="page.general.outro_text_filtered"></div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                selectedPlan: 'yearly',
                testimonial: {
                    carousel: null,
                    current: 0,
                    offset: 0,
                    total: 0,
                    x0: 0
                }
            }
        },
        methods: {
            gotoTestimonial: function (key) {
                if (key < 0) {
                    key = this.testimonial.total - 1;
                }

                if (key >= this.testimonial.total) {
                    key = 0;
                }

                this.testimonial.carousel.style.marginLeft = (this.testimonial.offset * -key) + 'px';
                this.testimonial.current = key;
            },
            initHeader: function () {
                const header = document.querySelector('.homepage__header');

                window.onscroll = function () {
                    if (document.documentElement.scrollTop > 65) {
                        header.classList.add('is-fixed');
                    } else {
                        header.classList.remove('is-fixed');
                    }
                };
            },
            initTestimonials: function () {
                this.testimonial.carousel = document.querySelector('.homepage__testimonials__carousel');
                this.testimonial.offset = document.querySelector('.homepage__testimonials .container').offsetWidth;
                this.testimonial.total = document.querySelectorAll('.homepage__testimonial').length;
            },
            moveTestimonialsFinish: function (event) {
                const dx = this.unifyEvent(event).clientX - this.testimonial.x0;
                const sensitivity = 20;

                if (dx < sensitivity * -1) {
                    this.gotoTestimonial(this.testimonial.current + 1);
                } else if (dx > sensitivity) {
                    this.gotoTestimonial(this.testimonial.current - 1);
                }
            },
            moveTestimonialsStart: function (event) {
                this.testimonial.x0 = this.unifyEvent(event).clientX;

                // disable scrolling
                document.body.style.overflowY = 'hidden';
            },
            scrollToVideo: function () {
                const offset = document.querySelector('#watch-video').offsetTop;

                window.scroll({
                    behavior: 'smooth',
                    top: offset
                });
            },
            selectPlan: function (plan) {
                this.selectedPlan = plan;
            },
            togglePlan: function () {
                this.selectedPlan = this.selectedPlan === 'monthly' ? 'yearly' : 'monthly';
            },
            unifyEvent: function (event) {
                return event.changedTouches ? event.changedTouches[0] : event;
            }
        },
        mounted() {
            this.initHeader();
            this.initTestimonials();
        },
        props: {
            page: {
                required: true,
                type: Object
            },
            subscription: {
                required: true,
                type: Object
            }
        }
    }
</script>
